"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormInnerData = exports.getInnerNode = exports.equalsIgnoreCase = exports.selectListContains = exports.findExecuteFirst = exports.isEmptyArray = exports.isNotEmptyArray = exports.isNotEmpty = exports.isEmpty = void 0;
var isEmpty = function (value) {
    if (typeof value === 'string') {
        return !value;
    }
    else if (['number', 'boolean', 'bigint', 'symbol'].includes(typeof value)) {
        return false;
    }
    else if (value == null) {
        return true;
    }
    else if (typeof value === 'object') {
        return !Object.keys(value).length;
    }
    return true;
};
exports.isEmpty = isEmpty;
var isNotEmpty = function (value) { return !(0, exports.isEmpty)(value); };
exports.isNotEmpty = isNotEmpty;
var isNotEmptyArray = function (arr) { return arr instanceof Array && (arr === null || arr === void 0 ? void 0 : arr.length); };
exports.isNotEmptyArray = isNotEmptyArray;
var isEmptyArray = function (arr) { return !(0, exports.isNotEmpty)(arr); };
exports.isEmptyArray = isEmptyArray;
var findExecuteFirst = function (arr, func, args) {
    for (var i = 0; i < (arr === null || arr === void 0 ? void 0 : arr.length); i++) {
        var val = func(arr[i], args);
        if (val) {
            return val;
        }
    }
    return null;
};
exports.findExecuteFirst = findExecuteFirst;
var selectListContains = function (list, listItem) {
    if (listItem === void 0) { listItem = ''; }
    return (list || []).find(function (item) { return (0, exports.equalsIgnoreCase)(item.dropdownMainLabel, listItem); });
};
exports.selectListContains = selectListContains;
var equalsIgnoreCase = function (source, target) {
    var src = (source || '').toLowerCase();
    var tgt = (target || '').toLowerCase();
    return src === tgt;
};
exports.equalsIgnoreCase = equalsIgnoreCase;
var getInnerNode = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var node = args[0];
    for (var i = 1; i < (args === null || args === void 0 ? void 0 : args.length); i++) {
        if (node == null) {
            return null;
        }
        node = node[args[i]];
    }
    return node;
};
exports.getInnerNode = getInnerNode;
// TODO: Above function does the same thing but somehow not working, need to revisit
var getFormInnerData = function (state, location) {
    return (location === null || location === void 0 ? void 0 : location.reduce(function (acc, val) {
        return acc[val];
    }, state)) || '';
};
exports.getFormInnerData = getFormInnerData;
